import * as AOS from 'aos';

/**
 * @description AOS
 */

export function setAos(): void {
  const body = $('body');
  body.delay(500).queue(() => {
    body
      .dequeue()
      .addClass('is-loaded')
      .delay(1000)
      .queue(() => {
        body.dequeue();
        AOS.init({
          offset: Math.floor(($(window).height() || 0) / 4),
          duration: 500,
          easing: 'ease',
          once: true,
        });
      });
  });
}
